import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function BonusPricingSection() {
  return <section id="compra" className="py-10 md:py-14 px-4 bg-white text-center scroll-mt-10" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-11">
          {/* BONUSES */}
          <div className="mb-10" data-id="element-12">
            <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-2" data-id="element-13">
              🎁 BONOS EXCLUSIVOS
            </h2>
            <p className="text-xl font-bold text-red-600 mb-8 bg-red-50 inline-block px-6 py-1.5 rounded-full" data-id="element-14">
              Gratis por el día de hoy
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-15">
              {/* Bono 1 */}
              <div className="bg-gray-50 rounded-2xl p-5 border border-gray-200 shadow-lg flex flex-col items-center text-center" data-id="element-16">
                <a href="#compra" className="w-full flex justify-center cursor-pointer hover:scale-105 transition-transform mb-4" data-id="element-17">
                  <img src="https://cdn.magicpatterns.com/uploads/1UYpxoJd9aP7LmDuavadk9/bono_1.png" alt="Bono 1" className="w-full max-w-[220px] drop-shadow-xl rounded-xl" loading="lazy" decoding="async" width={220} height={330} data-id="element-18" />
                </a>
                <h3 className="text-lg font-black text-yellow-600 mb-1" data-id="element-19">
                  🎁 Bono #1
                </h3>
                <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-20">
                  Sistema de planificación semanal
                </h4>
                <p className="text-sm text-gray-600 mb-3" data-id="element-21">
                  Organiza tus comidas fácilmente y evita improvisar.
                </p>
                <div className="bg-white p-2 rounded-xl border border-gray-100 shadow-sm inline-block mt-auto" data-id="element-22">
                  <p className="text-xs text-gray-500 line-through" data-id="element-23">
                    Valor: €19
                  </p>
                  <p className="text-lg font-black text-green-600" data-id="element-24">
                    HOY: GRATIS
                  </p>
                </div>
              </div>

              {/* Bono 2 */}
              <div className="bg-gray-50 rounded-2xl p-5 border border-gray-200 shadow-lg flex flex-col items-center text-center" data-id="element-25">
                <a href="#compra" className="w-full flex justify-center cursor-pointer hover:scale-105 transition-transform mb-4" data-id="element-26">
                  <img src="https://cdn.magicpatterns.com/uploads/sGfwGSRwdQMyTV1UHQS6bY/bono_2.png" alt="Bono 2" className="w-full max-w-[220px] drop-shadow-xl rounded-xl" loading="lazy" decoding="async" width={220} height={330} data-id="element-27" />
                </a>
                <h3 className="text-lg font-black text-yellow-600 mb-1" data-id="element-28">
                  🎁 Bono #2
                </h3>
                <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-29">
                  Guía completa de cocción en Airfryer
                </h4>
                <ul className="space-y-1 text-sm text-gray-700 font-medium mb-3" data-id="element-30">
                  <li className="flex items-center justify-center" data-id="element-31">
                    <span className="text-green-500 mr-1" data-id="element-32">✔</span> tabla de
                    tiempos
                  </li>
                  <li className="flex items-center justify-center" data-id="element-33">
                    <span className="text-green-500 mr-1" data-id="element-34">✔</span> temperaturas
                    correctas
                  </li>
                  <li className="flex items-center justify-center" data-id="element-35">
                    <span className="text-green-500 mr-1" data-id="element-36">✔</span> trucos de
                    cocción
                  </li>
                </ul>
                <div className="bg-white p-2 rounded-xl border border-gray-100 shadow-sm inline-block mt-auto" data-id="element-37">
                  <p className="text-xs text-gray-500 line-through" data-id="element-38">
                    Valor: €15
                  </p>
                  <p className="text-lg font-black text-green-600" data-id="element-39">
                    HOY: GRATIS
                  </p>
                </div>
              </div>

              {/* Bono 3 */}
              <div className="bg-gray-50 rounded-2xl p-5 border border-gray-200 shadow-lg flex flex-col items-center text-center" data-id="element-40">
                <a href="#compra" className="w-full flex justify-center cursor-pointer hover:scale-105 transition-transform mb-4" data-id="element-41">
                  <img src="https://cdn.magicpatterns.com/uploads/jMugWF6hu78dbiNaCWcBRa/bono_3.png" alt="Bono 3" className="w-full max-w-[220px] drop-shadow-xl rounded-xl" loading="lazy" decoding="async" width={220} height={330} data-id="element-42" />
                </a>
                <h3 className="text-lg font-black text-yellow-600 mb-1" data-id="element-43">
                  🎁 Bono #3
                </h3>
                <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-44">
                  Lista de compra saludable mensual
                </h4>
                <ul className="space-y-1 text-sm text-gray-700 font-medium mb-3" data-id="element-45">
                  <li className="flex items-center justify-center" data-id="element-46">
                    <span className="text-green-500 mr-1" data-id="element-47">✔</span> lista
                    semanal
                  </li>
                  <li className="flex items-center justify-center" data-id="element-48">
                    <span className="text-green-500 mr-1" data-id="element-49">✔</span> lista
                    mensual
                  </li>
                  <li className="flex items-center justify-center" data-id="element-50">
                    <span className="text-green-500 mr-1" data-id="element-51">✔</span> presupuesto
                    estimado
                  </li>
                </ul>
                <div className="bg-white p-2 rounded-xl border border-gray-100 shadow-sm inline-block mt-auto" data-id="element-52">
                  <p className="text-xs text-gray-500 line-through" data-id="element-53">
                    Valor: €12
                  </p>
                  <p className="text-lg font-black text-green-600" data-id="element-54">
                    HOY: GRATIS
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8" data-id="element-55">
              <CTAButton href="https://pagos.digipromarket.com/cart/56222402937158:1" text="👉 QUIERO EL MEGAPACK AHORA" className="text-xl md:text-2xl py-5" data-id="element-56" />
            </div>
          </div>

          {/* UPSELL PRICING SECTION */}
          <div className="mt-16 mb-10" data-id="element-57">
            {/* Transition Headline */}
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6" data-id="element-58">
              Espera — Hay personas que pierden el doble de peso con esta
              versión mejorada...
            </h2>

            {/* Intro Copy */}
            <div className="max-w-2xl mx-auto text-lg md:text-xl text-gray-700 space-y-4 mb-10 font-medium" data-id="element-59">
              <p className="font-bold text-gray-900 text-xl md:text-2xl" data-id="element-60">
                ¿Quieres resultados más rápidos y sin adivinar qué comer cada
                día?
              </p>
              <p data-id="element-61">
                Miles de personas ya están usando Adelgaza con Airfryer para
                transformar su cuerpo desde la cocina. Pero hay un grupo que lo
                está logrando el doble de rápido.
              </p>
              <p className="font-bold text-red-600" data-id="element-62">
                ¿La diferencia? Eligieron la Edición Completa.
              </p>
            </div>

            {/* PREMIUM OPTION (€19.99) */}
            <div className="bg-gradient-to-b from-gray-900 to-black rounded-3xl border-4 border-amber-500 shadow-[0_20px_50px_rgba(245,158,11,0.3)] p-6 md:p-10 relative mt-10 text-white transform hover:scale-[1.02] transition-transform duration-300" data-id="element-63">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-amber-500 text-amber-950 font-black px-8 py-1.5 rounded-full text-lg shadow-md whitespace-nowrap flex items-center gap-2" data-id="element-64">
                <span data-id="element-65">⭐</span> LA OPCIÓN MÁS INTELIGENTE
              </div>

              <div className="mt-4 mb-8" data-id="element-66">
                <img src="https://cdn.magicpatterns.com/uploads/rDA8D2UzPbGpHRS7krbyes/Portada_upsell.png" alt="Edición Premium Completa" className="w-full max-w-sm mx-auto drop-shadow-2xl rounded-xl" loading="lazy" decoding="async" width={384} height={576} data-id="element-67" />
              </div>

              <h3 className="text-2xl md:text-3xl font-black text-amber-400 mb-2" data-id="element-68">
                EDICIÓN COMPLETA ADELGAZA CON AIRFRYER
              </h3>
              <p className="text-lg text-gray-300 italic mb-8" data-id="element-69">
                Todo lo que necesitas. Sin excusas. Sin vueltas.
              </p>

              <div className="text-left max-w-md mx-auto mb-8 space-y-3 text-lg font-medium" data-id="element-70">
                <div className="flex items-start" data-id="element-71">
                  <span className="text-green-400 mr-3 text-xl" data-id="element-72">✅</span>
                  <span data-id="element-73">Los 6 Tomos del método Adelgaza con Airfryer</span>
                </div>
                <div className="flex items-start" data-id="element-74">
                  <span className="text-green-400 mr-3 text-xl" data-id="element-75">✅</span>
                  <span data-id="element-76">Los 3 Bonos exclusivos</span>
                </div>
                <div className="flex items-start bg-white/10 p-2 rounded-lg border border-white/20" data-id="element-77">
                  <span className="text-amber-400 mr-3 text-xl" data-id="element-78">✅</span>
                  <span className="text-amber-200 font-bold" data-id="element-79">
                    Plan Semanal de 30 días
                  </span>
                </div>
                <div className="flex items-start bg-white/10 p-2 rounded-lg border border-white/20" data-id="element-80">
                  <span className="text-amber-400 mr-3 text-xl" data-id="element-81">✅</span>
                  <span className="text-amber-200 font-bold" data-id="element-82">
                    Guía de compras inteligente
                  </span>
                </div>
                <div className="flex items-start bg-white/10 p-2 rounded-lg border border-white/20" data-id="element-83">
                  <span className="text-amber-400 mr-3 text-xl" data-id="element-84">✅</span>
                  <span className="text-amber-200 font-bold" data-id="element-85">
                    Calculadora de porciones
                  </span>
                </div>
                <div className="flex items-start" data-id="element-86">
                  <span className="text-green-400 mr-3 text-xl" data-id="element-87">✅</span>
                  <span data-id="element-88">Acceso inmediato — 100% digital</span>
                </div>
              </div>

              <div className="mb-8 bg-black/50 p-6 rounded-2xl border border-gray-800" data-id="element-89">
                <p className="text-lg text-gray-400 mb-2" data-id="element-90">
                  Todo esto por solo:
                </p>
                <p className="text-7xl md:text-8xl font-black text-amber-500 drop-shadow-md mb-2" data-id="element-91">
                  €19,99
                </p>
                <p className="text-sm font-bold text-green-400 bg-green-900/30 inline-block px-4 py-1 rounded-full" data-id="element-92">
                  Estás ahorrando más del 40% frente a comprar todo por separado
                </p>
              </div>

              <CTAButton href="https://pagos.digipromarket.com/cart/56222886723910:1" text="👉 SÍ, QUIERO LA EDICIÓN COMPLETA — €19,99" className="text-xl md:text-2xl py-5 shadow-[0_0_30px_rgba(34,197,94,0.5)]" data-id="element-93" />
              <p className="mt-4 text-sm text-gray-400 italic" data-id="element-94">
                Esta es la decisión que cambia todo
              </p>
            </div>

            {/* JUSTIFICATION BLOCK */}
            <div className="my-12 max-w-xl mx-auto" data-id="element-95">
              <h4 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-96">
                Pregúntate esto:
              </h4>
              <div className="bg-gray-50 p-6 rounded-2xl border border-gray-200 text-lg text-gray-700" data-id="element-97">
                <p className="mb-4" data-id="element-98">
                  Si por{' '}
                  <span className="font-bold text-green-600" data-id="element-99">€6 más</span>{' '}
                  puedes tener todo el sistema completo... ¿Tiene sentido
                  quedarte con la mitad?
                </p>
                <p className="mb-4" data-id="element-100">
                  La mayoría de las personas que eligen la opción básica
                  terminan deseando haber tomado la decisión completa desde el
                  principio.
                </p>
                <p className="font-black text-xl text-gray-900" data-id="element-101">
                  No seas esa persona.
                </p>
              </div>
            </div>

            {/* BASIC OPTION (€13.99) */}
            <div className="bg-gray-100 rounded-xl border-2 border-gray-400 p-6 md:p-8 max-w-lg mx-auto shadow-md" data-id="element-102">
              <p className="text-gray-700 font-semibold mb-2 text-lg" data-id="element-103">
                ¿Prefieres empezar solo con el paquete básico?
              </p>
              <p className="text-2xl font-bold text-gray-900 mb-1" data-id="element-104">
                6 Tomos + 3 Bonos por €13,99
              </p>
              <p className="text-sm text-gray-500 italic mb-5" data-id="element-105">
                (Sin el material adicional de la Edición Completa)
              </p>
              <a href="https://pagos.digipromarket.com/cart/56222402937158:1" className="inline-block bg-gray-800 hover:bg-gray-900 text-white font-bold text-lg py-3 px-8 rounded-xl shadow-md transition-colors" data-id="element-106">
                Continuar solo con el paquete básico →
              </a>
            </div>

            {/* URGENCY BLOCK */}
            <div className="mt-10 bg-red-50 border border-red-200 rounded-xl p-4 max-w-2xl mx-auto text-red-800" data-id="element-107">
              <p className="font-bold flex items-center justify-center gap-2 mb-1" data-id="element-108">
                <span className="text-xl" data-id="element-109">⚠️</span> Esta oferta combinada solo
                está disponible en esta página.
              </p>
              <p className="text-sm" data-id="element-110">
                Una vez que cierres esta ventana, el precio de la Edición
                Completa aumenta.
              </p>
            </div>
          </div>

          {/* GUARANTEE */}
          <div className="mt-8 max-w-2xl mx-auto" data-id="element-111">
            <div className="flex justify-center mb-3" data-id="element-112">
              <span className="text-5xl" data-id="element-113">🛡️</span>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-114">
              Garantía sin riesgo
            </h3>
            <p className="text-lg text-gray-700 mb-1 font-medium" data-id="element-115">
              Prueba el sistema durante 7 días.
            </p>
            <p className="text-base text-gray-600 mb-2" data-id="element-116">
              Si no te ayuda a cocinar más saludable y organizar tu
              alimentación, puedes solicitar la devolución completa.
            </p>
            <p className="text-lg font-bold text-gray-900" data-id="element-117">Sin preguntas.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}